import { USER_LANGUAGE_KEY } from "app/app-constants";

// for more properties to map see file 'metrix-login-service.ts'
export class userIdentity {
  email: string;
  personId: string;
  firstName: string;
  lastName: string;
  accessGroup: string;
  userLocale: string;
  roles: string[];
  place: { id: string; name: string };
  placeId: string;

  constructor() {
    this.email = this.getItemFromStorage("token_username");
    this.personId = this.getItemFromStorage("PersonId");
    this.firstName = this.getItemFromStorage("FirstName");
    this.lastName = this.getItemFromStorage("LastName");
    this.accessGroup = this.getItemFromStorage("SalesOrg");
    this.userLocale = this.getItemFromStorage(USER_LANGUAGE_KEY);
    this.roles = this.getItemFromStorage("AccessRoles")?.split(",")?.sort() ?? [];
    this.place = {
      id: this.getItemFromStorage("PlaceForPortalAccess"),
      name: this.getItemFromStorage("PlaceForPortalAccessName"),
    };
  }

  private getItemFromStorage = (name: string): string => {
    return localStorage.getItem(name);
  };
}
